module.exports = __webpack_public_path__ + "img/black-search.eb9f6bc1.svg";